/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface JoysticksKind {
}

export enum JoysticksKind_Enum {
  UNKNOWN = 0,
  GAMEPAD = 1,
  RC_TRANSMITTER = 2,
  SKYDIO_STICKS = 3,
  UNRECOGNIZED = -1,
}

export function joysticksKind_EnumFromJSON(object: any): JoysticksKind_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return JoysticksKind_Enum.UNKNOWN;
    case 1:
    case "GAMEPAD":
      return JoysticksKind_Enum.GAMEPAD;
    case 2:
    case "RC_TRANSMITTER":
      return JoysticksKind_Enum.RC_TRANSMITTER;
    case 3:
    case "SKYDIO_STICKS":
      return JoysticksKind_Enum.SKYDIO_STICKS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JoysticksKind_Enum.UNRECOGNIZED;
  }
}

export function joysticksKind_EnumToJSON(object: JoysticksKind_Enum): string {
  switch (object) {
    case JoysticksKind_Enum.UNKNOWN:
      return "UNKNOWN";
    case JoysticksKind_Enum.GAMEPAD:
      return "GAMEPAD";
    case JoysticksKind_Enum.RC_TRANSMITTER:
      return "RC_TRANSMITTER";
    case JoysticksKind_Enum.SKYDIO_STICKS:
      return "SKYDIO_STICKS";
    case JoysticksKind_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseJoysticksKind(): JoysticksKind {
  return {};
}

export const JoysticksKind = {
  encode(_: JoysticksKind, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): JoysticksKind {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJoysticksKind();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): JoysticksKind {
    return {};
  },

  toJSON(_: JoysticksKind): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<JoysticksKind>, I>>(base?: I): JoysticksKind {
    return JoysticksKind.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JoysticksKind>, I>>(_: I): JoysticksKind {
    const message = createBaseJoysticksKind();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
